var _class, _class2;

import { injectIsAboveTheFold } from '@udemy/design-system-utils';
import React from 'react';
export
/**
 * ### Image component.
 *
 * Renders an `<img>` element.
 *
 * @remarks
 *
 * There are three methods for controlling whether the image is
 * {@link https://developer.mozilla.org/en-US/docs/Web/Performance/Lazy_loading loaded lazily}.
 * In order of decreasing precedence:
 *
 * 1. Use the
 *    {@link https://developer.mozilla.org/en-US/docs/Web/HTML/Element/Img standard `loading` attribute}.
 * 2. Use the `lazy` prop (deprecated in favor of `loading` attribute).
 * 3. Wrap the component in an `AboveTheFoldProvider`.
 */
let Image = injectIsAboveTheFold(_class = (_class2 = class Image extends React.Component {
  constructor() {
    super(...arguments);

    this.loadingAttribute = () => {
      if (this.props.loading) {
        return this.props.loading;
      }

      if (this.props.lazy !== undefined) {
        return this.props.lazy ? 'lazy' : 'eager';
      }

      return this.props.isAboveTheFold ? 'eager' : 'lazy';
    };
  }

  render() {
    const {
      isAboveTheFold,
      lazy,
      loading,
      ...props
    } = this.props;
    const imageProps = { ...props,
      loading: this.loadingAttribute(),
      height: this.props.height === 'unset' ? undefined : this.props.height,
      width: this.props.width === 'unset' ? undefined : this.props.width
    };
    /* eslint-disable react/forbid-elements, jsx-a11y/alt-text */

    /* react/forbid-elements forbids img so that everyone uses this component instead,
     * but of course this component itself needs to render an img.
     * jsx-a11y/alt-text is not actually disabled. Alt is a required prop, and passed
     * to img through this.imageProps. ESLint just isn't smart enough to parse this.
     */

    return /*#__PURE__*/React.createElement("img", imageProps);
    /* eslint-enable react/forbid-elements, jsx-a11y/alt-text */
  }

}, _class2.defaultProps = {
  isAboveTheFold: false
}, _class2)) || _class;
//# sourceMappingURL=image.react-component.js.map